import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiZap, FiShield, FiTarget } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ServicePackages = ({ city, packages = [] }) => {
  if (!packages || packages.length === 0) return null;

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-orange-600 font-bold uppercase tracking-wider text-sm mb-4">Precision Growth</h2>
          <h3 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">{city} Service Packages</h3>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Strategic AEO and SEO frameworks designed specifically for the {city} economic landscape.
          </p>
        </div>

        <div className={`grid gap-8 ${packages.length === 1 ? 'max-w-2xl mx-auto' : 'md:grid-cols-2'}`}>
          {packages.map((pkg, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="bg-white rounded-[2.5rem] p-8 md:p-12 border border-slate-200 shadow-sm hover:shadow-xl hover:border-orange-500 transition-all group"
            >
              <div className="flex justify-between items-start mb-8">
                <div>
                  <span className="inline-block px-3 py-1 bg-orange-100 text-orange-600 rounded-full text-xs font-black uppercase tracking-widest mb-4">
                    {pkg.focus}
                  </span>
                  <h4 className="text-3xl font-bold text-slate-900 group-hover:text-orange-600 transition-colors">
                    {pkg.name}
                  </h4>
                </div>
                <div className="w-12 h-12 bg-slate-900 text-white rounded-2xl flex items-center justify-center">
                  <SafeIcon icon={i === 0 ? FiZap : FiShield} className="text-xl" />
                </div>
              </div>

              <p className="text-slate-600 mb-8 leading-relaxed">
                {pkg.description}
              </p>

              <div className="space-y-4 mb-10">
                {pkg.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-green-100 text-green-600 flex items-center justify-center shrink-0">
                      <SafeIcon icon={FiCheck} className="text-xs" />
                    </div>
                    <span className="text-slate-700 font-medium">{feature}</span>
                  </div>
                ))}
              </div>

              <div className="pt-8 border-t border-slate-100">
                <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 mb-4">AEO Protocol Status</p>
                <div className="flex items-center gap-2">
                  <div className="flex -space-x-2">
                    {[1, 2, 3].map(n => (
                      <div key={n} className="w-8 h-8 rounded-full bg-slate-100 border-2 border-white flex items-center justify-center">
                        <SafeIcon icon={FiTarget} className="text-[10px] text-orange-500" />
                      </div>
                    ))}
                  </div>
                  <span className="text-xs font-bold text-slate-600">Truth Protocol™ Ready</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicePackages;